import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { Client, CreateClientInput, CsUpdateClientInput } from 'api';
import { useClient } from 'hooks';
import { getImageSrc } from '../helpers';
import { Loaders } from 'components';
import { IMGIX_HOST } from 'settings';

interface IProps {
  height?: number;
  disableMargin?: boolean;
  client?: Client | CreateClientInput | CsUpdateClientInput;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    logo: {
      maxWidth: '100%',
      marginBottom: theme.spacing(3),

      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(3),
      },
    },
  });

const ClientLogo: FC<IPropsEnhanced> = ({ classes, disableMargin, height, client }) => {
  if (!client) {
    client = useClient();
  }
  if (!client || !client.image) {
    return null;
  }

  const { image } = client;
  const className = classNames({ [classes.logo]: !disableMargin });
  const { key } = image;
  const localUri = (image as any).localUri as Blob | undefined;
  const [working, setWorking] = useState(false);
  const [dataUrl, setDataUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    let mounted = true;
    if (localUri) {
      setWorking(true);
      const reader = new FileReader();
      reader.onload = e => {
        if (mounted) {
          setDataUrl(e.target.result as string);
          setWorking(false);
        }
      };
      reader.onerror = e => {
        if (mounted) {
          setDataUrl(null);
          setWorking(false);
        }
      };
      reader.readAsDataURL(localUri);
    }
    return () => {
      mounted = false;
    };
  }, [localUri]);

  function getSrcAttrs() {
    if (dataUrl) {
      return {
        src: dataUrl,
        style: { height },
      };
    } else {
      const imageUrl = `${IMGIX_HOST}/${key}?h=${height}&auto=format`;
      return getImageSrc(imageUrl);
    }
  }

  if (working) {
    return <Loaders.Standard />;
  }

  return <img className={className} {...getSrcAttrs()} />;
};

ClientLogo.defaultProps = {
  height: 50,
  disableMargin: false,
};

export default withStyles(styles)(ClientLogo);
